define('lq/tooltip',[
    'lq/html'
], function (html) {

    function Tooltip(drop, tooltipData, $element) {
        this.drop = drop;
        this.tooltipData = tooltipData;
        this.$element = $element;

        if (tooltipData.option === Tooltip.queryParent) {
            var parentDatasourceOutput = tooltipData.parentDatasourceOutput;
            drop.addOnceListener('DatasourceApplied', function (ctx) {
                var tooltip = ctx[parentDatasourceOutput];
                $element.attr('title', html.strip(tooltip));
            });
        }
    }

    Tooltip.isEnabled = function(tooltipData) {
        return !!tooltipData && (tooltipData.option !== 'Hardcoded' || !!tooltipData.hardcodedTooltip);
    };

    Tooltip.hardcoded = 'Hardcoded';
    Tooltip.parameter = 'Parameter';
    Tooltip.query = 'Query';
    Tooltip.queryParent = 'QueryParent';

    Tooltip.prototype.update = function (optionalTooltipOverride) {
        if (optionalTooltipOverride !== undefined) {
            this.$element.attr('title', html.strip(optionalTooltipOverride));
        } else if (this.tooltipData) {
            var $element = this.$element;

            if (this.tooltipData.option === Tooltip.hardcoded)
                $element.attr('title', html.strip(this.tooltipData.hardcodedTooltip));

            if (this.tooltipData.option === Tooltip.parameter)
                $element.attr('title', html.strip(this.drop.piping.parameters.getValue(this.tooltipData.parameter)));

            if (this.tooltipData.option === Tooltip.query) {
                var datasourceOutput = this.tooltipData.datasourceOutput;
                this.drop.piping.datasources.registerDatasourceListener(
                    this.tooltipData.datasource,
                    function (data) {
                        var tooltip = data.Results.length && data.Results[0][datasourceOutput];
                        $element.attr('title', html.strip(tooltip));
                    }
                );
            }
        }
    };

    return Tooltip;
});
